module.exports = __webpack_public_path__ + "d4d70e8719124f76fe82b090e81a39f2.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KN.svg
// module id = pFti
// module chunks = 0